var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-filters',[_c('c-filter-dropdown',{attrs:{"label":"Store","options":_vm.storeOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }